import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var $;

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  @Input()  title: string;
  @Input()  description: string;
  @Input() private callback: string;
  @Input() private callbackClose: string;
  @Input()  color: string;
  @Input()  text: string;

  @Output() public goToCallback: EventEmitter<string> = new EventEmitter;

  constructor() {
    this.color = this.defaultColor();
    this.text = this.defaultText();
  }

  ngOnInit() {
  }

  emit() {
    if (this.callbackClose) {
      this.goToCallback.emit(this.callbackClose);
    }
    if (this.callback) {
      this.goToCallback.emit(this.callback);
    }
  }

  close(){
    $('#confirm-modal').modal('hide');
  }

  open(data) {
    this.fill(data);
    $('#confirm-modal').modal('show');
  }

  accept() {
    this.emit();
    $('#confirm-modal').modal('hide');
  }

  fill(data) {
    this.title = data.title;
    this.description = data.description;
    this.callback = data.callback;
    this.callbackClose = data.callbackClose;
    if (data.color) {
      this.color = data.color;
    } else {
      this.color = this.defaultColor();
    }
    if(data.text) {
      this.text = data.text;
    } else {
      this.text = this.defaultText();
    }
  }

  defaultColor() {
    return 'success';
  }

  defaultText() {
    return 'Aceptar';
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/modals/confirm-modal/confirm-modal.component.ts